import React from 'react';
import styled from 'styled-components';
import MuiModal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import MuiButton from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import MUIPaper from '@material-ui/core/Paper';

const StyledModal = styled(MuiModal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledPaper = styled(MUIPaper)`
  max-width: 90vw;
  min-height: 100px;
  position: relative;
  background-color: ${props => props.theme.cardBg};
  color: ${props => props.theme.text};
  border-radius: 12px;
`;

const StyledButton = styled(MuiButton)`
  color: ${props => props.theme.focusText};
  padding: 16px;
  transition-duration: 150ms;
  transition-property: color;
  position: absolute;
  right: 0;
  top: 0;
  &.MuiButton-root {
    min-width: unset;
  }
  &:hover {
    color: ${props => props.theme.subtleText};
  }

  svg {
    font-size: 16px;
  }
`;

interface ModalProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

function Modal({open, onClose, children}: ModalProps) {
  return (
    <StyledModal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      disableEnforceFocus
      disableAutoFocus
    >
      <Fade in={open}>
        <StyledPaper>
          <StyledButton onClick={onClose}>
            <CloseIcon />
          </StyledButton>
          {children}
        </StyledPaper>
      </Fade>
    </StyledModal>
  );
}

export default Modal;
